import { FC, useCallback } from "react";
import { Control, RegisterOptions } from "react-hook-form";
import { find } from "lodash";

import { copy } from "shared/assets/copy";
import { Select, InputFieldProps, TimezoneValue, TimezoneOption } from "shared/components";
import { Globe } from "shared/assets/icons";
import { getRegionalSettingsOptions } from "shared/utils";
import { CITY_TIME_ZONES } from "shared/constants";

const { timeZone } = getRegionalSettingsOptions();

interface TimezoneSelectProps extends InputFieldProps {
  control: Control;
  validation?: RegisterOptions;
  setFieldValue?: (field: string, value: string | null) => void;
}

export const TimezoneSelect: FC<TimezoneSelectProps> = ({ value, placeholder, ...rest }) => {
  const filterOption = useCallback(({ value }: { value: string }, term: string) => {
    if (term) {
      const lowerCaseTerm = term.toLowerCase();
      if (value.toLowerCase().includes(lowerCaseTerm)) {
        return true;
      }

      return !!find(CITY_TIME_ZONES, ({ city, country, timezone }) => {
        if (
          timezone === value &&
          (city.toLowerCase().includes(lowerCaseTerm) ||
            country.toLowerCase().includes(lowerCaseTerm))
        ) {
          return true;
        }
        return false;
      });
    }
    return true;
  }, []);

  return (
    <Select
      {...rest}
      value={value}
      placeholder={placeholder || copy.form.selectTimezone}
      options={timeZone}
      filterOption={filterOption}
      prefixIcon={Globe}
      SelectValue={TimezoneValue}
      Option={TimezoneOption}
      isSearchable
      tabIndex={-1}
    />
  );
};
